import { MultiselectField } from '@frontend/design-system';

export const renderMultiSelectOptions = (options: string[], keys?: string[]) => {
  return options.map((option, index) => (
    <MultiselectField.Option key={index} value={keys ? keys[index] : option}>
      {option}
    </MultiselectField.Option>
  ));
};
